import { render } from "./Ctas.vue?vue&type=template&id=fc66b816&scoped=true"
import script from "./Ctas.vue?vue&type=script&lang=ts"
export * from "./Ctas.vue?vue&type=script&lang=ts"

import "./Ctas.vue?vue&type=style&index=0&id=fc66b816&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc66b816"

export default script